module.exports = __webpack_public_path__ + "img/08.56f705fa.png";